import Icon from '../components/Icon.vue'

Icon.register({"suitcase":{"width":1792,"height":1792,"paths":[{"d":"M640 384h512v-128h-512v128zM288 384v1280h-64q-92 0-158-66t-66-158v-832q0-92 66-158t158-66h64zM1408 384v1280h-1024v-1280h128v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h128zM1792 608v832q0 92-66 158t-158 66h-64v-1280h64q92 0 158 66t66 158z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/suitcase.js
// module id = 667
// module chunks = 0